import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=ef39c132&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef39c132')) {
      api.createRecord('ef39c132', component.options)
    } else {
      api.reload('ef39c132', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=ef39c132&", function () {
      api.rerender('ef39c132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oemp7vQ8aIdh/JS/videoIframe.vue"
export default component.exports